/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { Subject, takeUntil } from 'rxjs';

import { CoreConfigService } from '@xbaht/ui/core/services';

@Component({
  selector: 'xbaht-horizontal-layout',
  templateUrl: './horizontal-layout.component.html',
  styleUrl: './horizontal-layout.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HorizontalLayoutComponent implements OnInit, OnDestroy {
  public coreConfig: any;

  private _unsubscribe: Subject<void>;

  constructor(private _coreConfigService: CoreConfigService) {
    this._unsubscribe = new Subject<void>();
  }

  ngOnInit(): void {
    this._coreConfigService.config
      .pipe(takeUntil(this._unsubscribe))
      .subscribe((config: any) => {
        this.coreConfig = config;
      });
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }
}
